import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import StarIcon from "@material-ui/icons/Star";

const useStyles = makeStyles({
  root: {
    width: 200,
    height: 300,
    padding: "0 important!",
  },
  media: {
    height: 170,
  },
});

export default function PopUpCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia className={classes.media} image={props.mainPic} />
        <CardContent>
          <Typography>
            <StarIcon style={{ color: "red", fontSize: 15 }} /> {props.rate}
          </Typography>
          <Typography>{props.title}</Typography>

          <Typography>
            <span style={{ fontWeight: "bold", fontSize: 18 }}>
              {props.price}
            </span>
            /đêm
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
